import { type ClientLabel, ClientLabelType } from './clientLabel.types';

export enum WorkspaceFeature {
    DAM = 'dam',
    Projects = 'projects',
    Calendar = 'calendar',
    Security = 'security',
    API = 'api',
    CustomFields = 'custom-fields',
    Customization = 'customization',
    AccessRequests = 'access-requests',
    DownloadOptions = 'download-options',
    ArteAvidExport = 'arte-avid-export',
    CalendarEventsExport = 'calendar-events-export'
}

export type WorkspaceLabels = {
    [ClientLabelType.Event]: ClientLabel<ClientLabelType.Event>[];
    [ClientLabelType.Contact]: ClientLabel<ClientLabelType.Contact>[];
    [ClientLabelType.Item]: ClientLabel<ClientLabelType.Item>[];
    [ClientLabelType.Cast]: ClientLabel<ClientLabelType.Cast>[];
};
